<div class="gms-main-container">
  <router-outlet></router-outlet>
</div>